import Script from "next/script";
import { PaymentsScript } from "../../../domain/types";

//

export const TiptopScript: PaymentsScript = ({ ...props }) => {
  return (
    <>
      <Script
        strategy="afterInteractive"
        src="https://widget.tiptoppay.kz/bundles/widget.js"
        {...props}
      />
      <Script
        strategy="afterInteractive"
        src="https://widget.tiptoppay.kz/bundles/paymentblocks.js"
        {...props}
      />
    </>
  );
};
